// @flow

import * as React from "react";

import { DefaultErrorPage } from "tabler-react";
import type { Props as DefaultErrorProps } from "tabler-react";

function Error404Page({
  title = "404",
  subtitle = "Uups... Du fandt en fejlside...",
  details = "Beklager, men denne side findes ikke...",
  action,
}: DefaultErrorProps): React.Node {
  return (
    <DefaultErrorPage
      title={title}
      subtitle={subtitle}
      details={details}
      action={action}
    />
  );
}

export default Error404Page;